import './cambridge.scss';
import { setupLayout } from '../../Shared/layout';
import * as $ from 'jquery';
import 'owl.carousel/dist/owl.carousel';
import '@fancyapps/fancybox';
import { setupEnquiryForm, EnquiryFormType } from '../../Shared/Component/EnquiryForm/enquiry-form';

setupLayout();
setupEnquiryForm(EnquiryFormType.Course);

$(document).ready(function () {
    $('.owl-cetificate').owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1
            },
            426: {
                items: 2
            },
            1025: {
                items: 2
            }
        }
    });
});